import { Button, DialogActions, DialogContent, Grid } from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/styles";
import md5 from "md5";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import usersStore from "../../../Store/UsersStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

function Form(props) {
  const { classes, width, data, cancel } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [, usersActions] = usersStore();
  const [state, setState] = React.useState({
    formData: {
      id: "",
      password: "",
      repeatPassword: "",
    },
  });
  const [componentWillMount] = React.useState(false);

  React.useEffect(() => {
    if (data) {
      setState({
        formData: {
          id: data.id,
          password: "",
          repeatPassword: "",
        },
      });
    }
  }, [componentWillMount, data]);

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    if (value !== state.formData.password) {
      return false;
    }
    return true;
  });

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };
  const handleSubmit = (event) => {
    confirm("Submit", "Are you sure to Change Password ?").then(
      async (onProcess) => {
        const { formData } = state;
        const params = [
          {
            op: "replace",
            path: "/password",
            value: md5(formData.password),
          },
        ];
        let notif = `Successfully update password`;
        await usersActions.patch(formData.id, params, notif);
        handleCloseDialog();
        cancel();
      }
    );
  };

  return (
    <CustomizedDialogs
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent dividers>
        <ValidatorForm
          id="myform"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <Grid container justify="center">
            <Grid container justify="center" item xs={width === "lg" ? 8 : 12}>
              <Grid
                container
                item
                xs={11}
                spacing={1}
                style={{ paddingBottom: 30 }}
              >
                <TextValidator
                  id="password"
                  label="Password"
                  name="password"
                  readOnly
                  className={classes.textField}
                  margin="normal"
                  value={state.formData.password}
                  variant="outlined"
                  autoComplete="new-password"
                  inputProps={{ maxLength: 51 }}
                  validators={["required", "maxStringLength:50"]}
                  errorMessages={[
                    "Password is required",
                    "maximum character is 50",
                  ]}
                  type="password"
                  onChange={handleChange}
                  autoFocus
                />
                <TextValidator
                  label="Confirm Password"
                  onChange={handleChange}
                  className={classes.textField}
                  name="repeatPassword"
                  type="password"
                  variant="outlined"
                  margin="normal"
                  validators={["isPasswordMatch", "required"]}
                  errorMessages={[
                    "Password mismatch",
                    "Please input password confirmation",
                  ]}
                  value={state.formData.repeatPassword}
                />
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleCloseDialog();
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          form="myform"
          variant="contained"
          style={{ marginRight: 30 }}
          color="primary"
        >
          Submit
        </Button>
      </DialogActions>
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};

export function changePasswordForm(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
